import type { Type_Workflow } from '../Type/Type.hive'
import { Unit_fetchForTypes, Unit_fetchByIds } from '../Unit/Unit.fetch'
import { isAppActivityWorkflow } from '../../../app-core/lib/workflow/Workflow'
import {
    readyToStart,
    fetchUnitsForSubjectPicker,
    type UnitsForSubjectPicker,
} from '../../../app-core/lib/flow/SubjectType'
import { IDB_unitTypesReadAll } from '../IDB/IDB.table.unitType'
import { I18N_replaceNameSlugs } from '../I18N/I18N.slugs'
import { arrayToMap } from '../../../shared/lib/helpers.no-deps'

export type PossibleUnitSubjects = UnitsForSubjectPicker

export function Flow_getSubjectType(workflow: Type_Workflow) {
    if (workflow == null || isAppActivityWorkflow(workflow)) return null
    return workflow.flow.subjectType ?? null
}

export async function Flow_fetchPossibleUnitSubjects(workflow: Type_Workflow): Promise<PossibleUnitSubjects> {
    const subjectType = Flow_getSubjectType(workflow)
    return fetchUnitsForSubjectPicker(subjectType, Unit_fetchForTypes, Unit_fetchByIds)
}

export async function Flow_fetchPossibleUnits(): Promise<PossibleUnitSubjects> {
    const types = await IDB_unitTypesReadAll().then(I18N_replaceNameSlugs)
    const allUnits = await Promise.all(
        types.map(async (type) =>
            fetchUnitsForSubjectPicker(
                {
                    type: 'SubjectTypeUnit',
                    unitType: type.id,
                },
                Unit_fetchForTypes,
                Unit_fetchByIds
            )
        )
    )
    const unitTypesMap = arrayToMap(types, 'id')

    return {
        units: allUnits
            .flatMap((u) => u.units)
            .map((unit) => ({
                ...unit,
                typeName: unitTypesMap.get(unit.type)?.name,
            })),
        ancestors: [],
    }
}

/**
 * This determines whether enough extra information has been found to statisfy the subject type of a flow
 * Currently this means that if the flow is expecting a unit subject, a unit subject must have been picked
 * But this could be expanded: if the flow is expecting a location subject, a location must have been picked...etc
 */
export function Flow_readyToStartWorkflow(workflow: Type_Workflow, args: { subjectUnitId?: number }) {
    return readyToStart(Flow_getSubjectType(workflow), args)
}
